export const scape_report = 'scape-report';


const scape_report_route = {
    scapeReportHome: `/shoal/${scape_report}`
}

export default scape_report_route